import GlobalsDataById from 'scoreboard/components/globals-data-by-id'

var databases = new GlobalsDataById('databases', 'database')

export default databases

databases.__filename__ = 'components/databases.js'
